export default "__VITE_ASSET__Ddrin0lc__"